module.exports = __webpack_public_path__ + "img/Care1.5e544f59.png";